import React from 'react';

// Custom Col component to replace @deere/ux.uxframe-react Col
const Col = ({ children, className = '', xs, sm, md, lg, xl, ...props }) => {
  const baseClasses = 'flex flex-col';
  const classes = `${baseClasses} ${className}`;
  
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Col;
